import * as adminApi from '../services/api/admin';
import * as accountApi from '../services/api/account';

import * as sessionActions from '../actions/session';

import {SubmissionError} from "redux-form";

export const USER_TO_EDIT_RECEIVED = 'USER_TO_EDIT_RECEIVED';
export const SEARCH_USERS_RECEIVED = 'SEARCH_USERS_RECEIVED';
export const SEARCH_USERS_TEXT_CHANGED = 'SEARCH_USERS_TEXT_CHANGED';
export const LOAD_MORE_USERS_RECEIVED = 'LOAD_MORE_USERS_RECEIVED';
export const IS_SEARCHING_USERS_CHANGED = 'IS_SEARCHING_USERS_CHANGED';
export const RESET_SEARCH_USERS = 'RESET_SEARCH_USERS';
export const IS_REMOVING_USER_STATUS_CHANGED = 'IS_REMOVING_USER_STATUS_CHANGED';
export const IS_AUTHENTICATING_AS_USER_STATUS_CHANGED = 'IS_AUTHENTICATING_AS_USER_STATUS_CHANGED';
export const USER_TO_DELETE_UPDATED = 'USER_TO_DELETE_UPDATED';
export const USER_TO_AUTHENTICATE_UPDATED = 'USER_TO_AUTHENTICATE_UPDATED';
export const SET_IS_ACCOUNT_LOCKED = 'SET_IS_ACCOUNT_LOCKED';

export function changeUserToDelete(user) {
    return {
        type: USER_TO_DELETE_UPDATED,
        user
    }
}

export function changeUserToAuthenticate(user) {
    return {
        type: USER_TO_AUTHENTICATE_UPDATED,
        user
    }
}

export function deleteUser(user) {

    return (dispatch, getState) => {

        dispatch(removingUserStatusChanged(true));

        return accountApi
            .remove(user.id)
            .then(() => {
                dispatch(removingUserStatusChanged(false));
                dispatch(changeUserToDelete(null));
                dispatch(searchUsers(getState().admin.searchText));
            });
    }
}

export function authenticateAsUser(user) {

    return dispatch => {

        dispatch(authenticatingAsUserStatusChanged(true));

        return accountApi
            .authenticateAsUser(user.id)
            .then(res => {
                const { session_user } = res.payload;
                window.config.session_user = session_user;

                dispatch(sessionActions.setSessionUser(session_user));
                dispatch(authenticatingAsUserStatusChanged(false));
                dispatch(changeUserToAuthenticate(null));
            });
    }
}

export function removingUserStatusChanged(isRemoving) {
    return {
        type: IS_REMOVING_USER_STATUS_CHANGED,
        isRemoving
    }
}

export function authenticatingAsUserStatusChanged(isAuthenticating) {
    return {
        type: IS_AUTHENTICATING_AS_USER_STATUS_CHANGED,
        isAuthenticating
    }
}

export function changeSearchUserText(searchText) {
    return {
        type: SEARCH_USERS_TEXT_CHANGED,
        searchText
    }
}

export function changeIsSearchingUsers(isSearching) {
    return {
        type: IS_SEARCHING_USERS_CHANGED,
        isSearching
    }
}

export function getUserById(userId) {

    return dispatch => {

        return accountApi
            .getOne(userId)
            .then(res => dispatch(userReceived(res.payload)));
    }
}

export function userReceived(user) {

    return {
        type: USER_TO_EDIT_RECEIVED,
        user
    }
}

export function saveUserAccount(user) {

    return dispatch => {

        return adminApi
            .saveUserAccount(user)
            .then(res => dispatch(userReceived(res.payload)))
            .catch((res) => {
                throw new SubmissionError({
                    ...res.payload,
                    _error: res.payload
                });
            });
    }
}

export function loadMoreUsers(searchText) {

    return (dispatch, getState) => {

        const userCount = getState().admin.searchUsers.length;

        dispatch(changeIsSearchingUsers(true));
        dispatch(changeSearchUserText(searchText));

        return accountApi
            .search(searchText, { offset: userCount, limit: 10 })
            .then(res => {

                const isMoreToLoad = res.meta.total > userCount + res.payload.length;

                dispatch(loadMoreUsersReceived(res.payload, isMoreToLoad));
                dispatch(changeIsSearchingUsers(false));
            });
    }
}

export function searchUsers(searchText) {

    return dispatch => {

        dispatch(changeIsSearchingUsers(true));
        dispatch(changeSearchUserText(searchText));

        return accountApi
            .search(searchText, { offset: 0, limit: 10 })
            .then(res => {

                const isMoreToLoad = res.meta.total > res.payload.length;

                dispatch(searchUsersReceived(res.payload, isMoreToLoad));
                dispatch(changeIsSearchingUsers(false));
            });
    }
}

export function searchUsersReceived(users, isMoreToLoad) {
    return {
        type: SEARCH_USERS_RECEIVED,
        users,
        isMoreToLoad
    }
}

export function loadMoreUsersReceived(users, isMoreToLoad) {
    return {
        type: LOAD_MORE_USERS_RECEIVED,
        users,
        isMoreToLoad
    }
}

export function resetUserList() {
    return {
        type: RESET_SEARCH_USERS
    }
}

function setIsAccountLocked(isAccountLocked) {
    return {
        type: SET_IS_ACCOUNT_LOCKED,
        isAccountLocked
    }
}

export function getIsAccountLocked(userId) {
    return dispatch => {
        const success = res => {
            dispatch(setIsAccountLocked(res.payload));
        }

        return adminApi
            .getIsAccountLocked(userId)
            .then(success)
            .catch((res) => {
                throw new SubmissionError({
                    ...res.payload,
                    _error: res.payload
                });
            });
    }
}

export function unlockAccount(userId){
    return dispatch => {
        return adminApi
            .unlockUserAccount(userId)
            .then(() => {
                dispatch(setIsAccountLocked(0));
            })
            .catch((res) => {
                throw new SubmissionError({
                    ...res.payload,
                    _error: res.payload
                });
            });
    }
}